






















import { Vue, Component, Prop } from 'vue-property-decorator';
import WxSubscribe from '@tencent/wphk-components-wx-subscribe/index.vue';
import { isSupportWxSubscribe } from '@tencent/wphk-components-wx-subscribe/wx-subscribe-util';
import { SubTplInfo } from '@tencent/wphk-components-merchant-favorites/src/types';
import { handleSubscribeRes, checkIfSubscribed } from '@tencent/wphk-components-merchant-favorites/src/business';
import { language, url } from '@tencent/ppd-base-libs';
import { biClick } from '@tencent/fit-bi-sdk';

// 从模版消息过来
const fromTplInfo = url.getUrlParam('fromTplInfo');

@Component({
  components: {
    WxSubscribe,
  },
})
export default class SubscribeDialog extends Vue {
  @Prop() chnId!: string;
  @Prop() subTplInfo!: SubTplInfo[];
  isSubscribed = true;
  isHide = false;
  showWxSubscribe = isSupportWxSubscribe();
  lang = language.getLanguage();
  get tplIds() {
    return (this.subTplInfo || []).map(item => item.tplId);
  }
  get show() {
    return this.showWxSubscribe // 是否微信支持
    && !this.isHide // 是否隐藏
    && fromTplInfo === '1' // 是否从消息模版来
    && sessionStorage.getItem('hasShowSubscribeDialog') !== '1' // 是否已经弹出过
    && !this.isSubscribed; // 是否已订阅
  }
  async created() {
    this.isSubscribed = await checkIfSubscribed(this.chnId, this.subTplInfo);
  }
  mounted() {
    document.body.appendChild(this.$el);
  }
  onClose() {
    this.close();
    biClick('subscribe-dialog.close_click|订阅弹窗关闭');
  }
  close() {
    this.isHide = true;
    sessionStorage.setItem('hasShowSubscribeDialog', '1');
  }
  subSucc(res) {
    biClick('subscribe-dialog.sub_click|订阅点击');
    const hasOneAccept =  handleSubscribeRes(res, this.chnId, this.subTplInfo);
    if (hasOneAccept) {
      biClick('subscribe-dialog.sub_succ|订阅消息成功');
    }
    this.close();
  }
  subFail() {
    this.close();
    biClick('subscribe-dialog.sub_fail|订阅消息失败');
  }
}
